import { staticComponentValueConverter } from '../StaticComponentValues';
import { useSelector } from 'react-redux';

function Description_2({ item }) {
  const customization = staticComponentValueConverter(item?.customization);
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const text = staticComponentValueConverter(item?.data?.text);
  const selectedProduct = useSelector(state => state.themeSlice.selectedProduct);
  const firstProduct = selectedProduct?.data;
  if (!firstProduct?.description) return <></>;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        textAlign: 'left',
        gap: 5,
      }}
      className="py-2.5 mx-3 "
    >
      {customization?.isShowDescriptionTitle === 'show' && (
        <div
          style={{
            fontSize: customization?.descriptionTitleTextSize,
            fontWeight: customization?.descriptionTitleTextWeight,
            color: customization?.descriptionTitleTextColor,
            textAlign: customization?.descriptionTitleTextAlignment,
            fontStyle: customization?.descriptionTitleTextStyle,
            marginBottom: 10,
            width: '100%',
          }}
        >
          {item?.data?.text}
        </div>
      )}
      <div
        style={{
          fontSize: customization?.ProductTitleTextSize,
          fontWeight: customization?.ProductTitleTextWeight,
          color: customization?.ProductTitleTextColor,

          fontStyle: customization?.ProductTitleTextStyle,
          marginBottom: 10,
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div>
          {customization?.isShowProductTitle === 'show' && (
            <div
              style={{
                fontSize: customization?.productTitleTextSize,
                color: customization?.productTitleTextColor,
                textAlign: customization?.productTitleTextAlignment,
                fontStyle: customization?.productTitleTextStyle,
                fontWeight: customization?.productTitleTextWeight,
              }}
            >
              {customization?.productNameText}
            </div>
          )}
        </div>
        <div>
          {customization?.isOpenDescriptionAccordion === 'show' ? (
            <svg width="20px" height="20px" viewBox="0 0 0.5 0.5" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.25 0.35a0.025 0.025 0 0 1 -0.018 -0.007l-0.125 -0.125a0.025 0.025 0 1 1 0.035 -0.035L0.25 0.29l0.107 -0.107a0.025 0.025 0 1 1 0.035 0.035l-0.125 0.125A0.025 0.025 0 0 1 0.25 0.35"
                fill="#5C5F62"
              />
            </svg>
          ) : (
            <svg width="20px" height="20px" viewBox="0 0 0.5 0.5" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.2 0.4a0.025 0.025 0 0 1 -0.018 -0.043L0.29 0.25 0.182 0.143a0.025 0.025 0 1 1 0.035 -0.035l0.125 0.125a0.025 0.025 0 0 1 0 0.035l-0.125 0.125A0.025 0.025 0 0 1 0.2 0.4"
                fill="#5C5F62"
              />
            </svg>
          )}
        </div>
      </div>
      {customization?.isOpenDescriptionAccordion === 'show' ? (
        <div dangerouslySetInnerHTML={{ __html: firstProduct?.description }}></div>
      ) : (
        <></>
      )}
    </div>
  );
}

export default Description_2;
